import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { trackInitiateCheckout } from '../utils/metaPixel';
export function HeroSection() {
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('pricing');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="bg-wellness-white pt-32 pb-20 px-6 min-h-[90vh] flex items-center" id="hero" data-id="element-57">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-58">
        <motion.div initial={{
        opacity: 0,
        x: -50
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8
      }} className="flex flex-col items-start space-y-8" data-id="element-59">
          <div className="space-y-4" data-id="element-60">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-serif font-bold text-wellness-dark leading-tight" data-id="element-61">
              Reset de Hinchazón en 7 Días
            </h1>
            <p className="text-xl md:text-2xl text-wellness-dark/80 font-light max-w-xl leading-relaxed" data-id="element-62">
              La guía práctica para sentirte más liviana, cómoda y con energía —
              sin dietas extremas.
            </p>
          </div>

          <div className="w-full" data-id="element-63">
            <a href="https://cuerpoencalma.it.com/cart/49295445262573:1" target="_blank" rel="noopener noreferrer" onClick={() => trackInitiateCheckout('hero_cta')} className="inline-block w-full md:w-auto bg-wellness-gold text-white px-10 py-4 rounded-full font-bold text-lg tracking-wide shadow-xl shadow-wellness-gold/30 hover:bg-yellow-600 transition-all hover:scale-105 active:scale-95 text-center" data-id="element-64">
              QUIERO MI GUÍA — $6.36
            </a>
            <div className="mt-4 flex flex-wrap items-center gap-4 text-sm text-wellness-dark/70 font-medium" data-id="element-65">
              <span className="flex items-center gap-1" data-id="element-66">
                <CheckCircle2 className="w-4 h-4 text-wellness-green" data-id="element-67" /> Acceso
                inmediato
              </span>
              <span className="flex items-center gap-1" data-id="element-68">
                <CheckCircle2 className="w-4 h-4 text-wellness-green" data-id="element-69" /> PDF
                descargable
              </span>
              <span className="flex items-center gap-1" data-id="element-70">
                <CheckCircle2 className="w-4 h-4 text-wellness-green" data-id="element-71" /> Pago
                seguro
              </span>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 50
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative w-full max-w-md mx-auto lg:max-w-full" data-id="element-72">
          <div className="relative aspect-[4/5] rounded-3xl overflow-hidden shadow-2xl shadow-wellness-dark/10 border-8 border-white/50 bg-white" data-id="element-73">
            <img src="https://cdn.magicpatterns.com/uploads/wMkfvm4BuJr2KRSfQMmcJi/CONCEPTO_4.png" alt="Reset de Hinchazón en 7 Días Ebook" className="w-full h-full object-cover object-center" data-id="element-74" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent pointer-events-none" data-id="element-75" />
          </div>

          {/* Decorative elements */}
          <div className="absolute -top-6 -right-6 w-24 h-24 bg-wellness-sage/20 rounded-full blur-2xl -z-10" data-id="element-76" />
          <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-wellness-gold/10 rounded-full blur-3xl -z-10" data-id="element-77" />
        </motion.div>
      </div>
    </section>;
}